import { render, staticRenderFns } from "./ListNew.vue?vue&type=template&id=1b35899c"
import script from "./ListNew.vue?vue&type=script&lang=js"
export * from "./ListNew.vue?vue&type=script&lang=js"
import style0 from "./ListNew.vue?vue&type=style&index=0&id=1b35899c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports